<div class="dialog-wrapper">
  <h3 mat-dialog-title>{{ data.title }}</h3>
  <div mat-dialog-content class="p-0">
    <av-table-card
      [titleKey]="'app.device.actions.bitlocker_keys.recovery_key'"
      [icon]="'vpn_key'"
      [columns]="columns"
      [rows]="rows"
      [emptyTextKey]="'shared.general.labels.no_data'"
      [pageSize]="5"
    />
  </div>
  <div mat-dialog-actions>
    <div class="dialog-actions">
      <button mat-flat-button color="primary" (click)="onClose()">
        <span>{{ 'shared.general.buttons.close' | translate }}</span>
      </button>
    </div>
  </div>
</div>